import { ProcedureUnitTypeRule } from '../../models/unit-type-rules-config';
import { UnitTypes } from '@modules/teeth-diagram/models/unit-type.enum';
import { allTeeth, molarTeeth } from '../teeth-sets';
import { LimitedFeatures } from '@shared/models/limited-features';
import { SoftwareOptions } from '@shared/models/enums/enums';
import { procedureMapComposites } from '../../models/procedure-map-composites';

export const rulesForFixedRestorative: ProcedureUnitTypeRule = {
	ProcedureMaps: [procedureMapComposites.fixedRestorativeAll],
	TeethRules: [
		{
			Ids: allTeeth,
			UnitAndMaterialRules: {
				UnitTypeRules: [
					{
						Id: UnitTypes.Regular
					},
					{
						Id: UnitTypes.Missing
					},
					{
						Id: UnitTypes.Crown
					},
					{
						Id: UnitTypes.Crown_ThreeQuarters
					},
					{
						Id: UnitTypes.ImplantBased
					},
					{
						Id: UnitTypes.EggshellCrown,
						RestrictionUnitTypes: {
							LimitedFeatures: LimitedFeatures.EggshellCrown
						}
					},
					{
						Id: UnitTypes.MockupTooth,
						RestrictionUnitTypes: {
							LimitedFeatures: LimitedFeatures.MockupTooth,
							SoftwareOptions: [SoftwareOptions.EnableMockUpIndication]
						}
					}
				],
				UnitTypesAdditionalRules: {
					UnitTypesInput: [UnitTypes.Regular],
					UnitTypesAddedOutput: [UnitTypes.Detachable]
				}
			}
		},
		{
			Ids: molarTeeth,
			UnitAndMaterialRules: {
				UnitTypeRules: [
					{
						Id: UnitTypes.Inlay
					},
					{
						Id: UnitTypes.Onlay
					}
				]
			}
		},
		{
			Ids: allTeeth,
			UnitAndMaterialRules: {
				UnitTypeRules: [
					{
						Id: UnitTypes.VeneerOrLaminates
					}
				]
			}
		}
	]
};
